import type { ENV as EnvType } from "./types"

export const getCurrentEnv = (): EnvType => process.env.NEXT_PUBLIC_ENV || "production"

export const isEnvLocal = (): boolean => getCurrentEnv() === "local"
export const isEnvFeature = (): boolean => getCurrentEnv() === "feature"
export const isEnvStaging = (): boolean => getCurrentEnv() === "staging"
